<template>
  <div class="gx-reg">
    <stars-canvas :count="80" :meteor-max="2" :meteor-gap="700" fixed />
    <float-pts :count="12" fixed />
<!--    <div class="gx-reg__orb gx-reg__orb&#45;&#45;1"></div>
    <div class="gx-reg__orb gx-reg__orb&#45;&#45;2"></div>-->

    <button class="gx-reg__back" @click="$router.push('/')">
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
        <path d="M8 1.5L3 6.5l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      返回首页
    </button>

    <!-- 左侧品牌区 -->
    <div class="gx-reg__left">
      <div class="gx-reg__brand">
<!--        <div class="gx-reg__tree">🌳</div>-->
        <img src="https://xinghaohuo.oss-cn-beijing.aliyuncs.com/logo.png" style="width: 100px;height: 100px">
        <div class="gx-reg__name">观星树</div>
        <div class="gx-reg__slogan">AI智能店群运营</div>
        <div class="gx-reg__sub">致力店群无人化</div>
        <div class="gx-reg__divider"></div>
        <div class="gx-reg__stats">
          <div v-for="s in stats" :key="s.l" class="gx-reg__stat">
            <div class="gx-reg__stat-v">{{ s.v }}</div>
            <div class="gx-reg__stat-l">{{ s.l }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧表单区 -->
    <div class="gx-reg__right">
      <div class="gx-reg__panel">
        <div class="gx-reg__head">
          <div class="gx-reg__head-icon">🌱</div>
          <h2 class="gx-reg__title">加入观星树</h2>
          <p class="gx-reg__en">BEGIN YOUR JOURNEY</p>
        </div>

        <!-- 步骤指示 -->
        <div class="gx-reg__steps">
          <div v-for="(l, i) in stepLabels" :key="l" class="gx-reg__step" :class="{ 'gx-reg__step--done': i < step, 'gx-reg__step--active': i === step }">
            <div v-if="i > 0" class="gx-reg__step-line" ></div>
            <div class="gx-reg__step-dot" :class="{ 'gx-reg__step-dot--done': i < step, 'gx-reg__step-dot--active': i === step }">
              <span v-if="i < step" class="gx-reg__step-check">✓</span>
              <span v-else class="gx-reg__step-num">{{ i + 1 }}</span>
            </div>
            <span class="gx-reg__step-label">{{ l }}</span>
          </div>
        </div>

        <div class="gx-reg__card">
          <!-- 完成态 -->
          <div v-if="step === 3" class="gx-reg__done">
            <div class="gx-reg__done-icon">✅</div>
            <div class="gx-reg__done-title">注册成功</div>
            <div class="gx-reg__done-sub">欢迎加入观星树，快去登录开启 AI 智能运营之旅</div>
            <button class="gx-reg__submit" @click="$emit('login')">立即登录</button>
          </div>

          <!-- 第一步：姓名+手机号 + 邀请码 -->
          <div v-else-if="step === 0">
            <div class="gx-input">
              <label class="gx-input__label">您的姓名</label>
              <input
                  v-model="form.name"
                  class="gx-input__field"
                  :class="{ 'gx-input__field--foc': focusField === 'name' }"
                  placeholder="请输入真实姓名"
                  @focus="focusField = 'name'"
                  @blur="focusField = ''"
              />
            </div>
            <div class="gx-input">
              <label class="gx-input__label">手机号码</label>
              <input
                  type="tel"
                v-model="form.phone"
                maxlength="11"
                class="gx-input__field"
                :class="{ 'gx-input__field--foc': focusField === 'phone' }"
                placeholder="请输入手机号"
                @focus="focusField = 'phone'"
                @blur="focusField = ''"
              />
            </div>
            <div class="gx-input">
              <label class="gx-input__label">邀请码（选填）</label>
              <input
                v-model="form.invite"
                class="gx-input__field"
                :class="{ 'gx-input__field--foc': focusField === 'invite' }"
                placeholder="请输入邀请码"
                @focus="focusField = 'invite'"
                @blur="focusField = ''"
              />
            </div>
            <button class="gx-reg__submit" @click="nextStep">下一步</button>
          </div>

          <!-- 第二步：设置密码 -->
          <div v-else-if="step === 1">
            <div class="gx-input">
              <label class="gx-input__label">设置密码</label>
              <input
                v-model="form.pwd"
                type="password"
                class="gx-input__field"
                :class="{ 'gx-input__field--foc': focusField === 'pwd' }"
                placeholder="至少6位，建议包含字母数字"
                @focus="focusField = 'pwd'"
                @blur="focusField = ''"
              />
            </div>
            <div class="gx-input">
              <label class="gx-input__label">确认密码</label>
              <input
                v-model="form.pwd2"
                type="password"
                class="gx-input__field"
                :class="{ 'gx-input__field--foc': focusField === 'pwd2' }"
                placeholder="再次输入密码"
                @focus="focusField = 'pwd2'"
                @blur="focusField = ''"
              />
            </div>

            <button class="gx-reg__submit" @click="nextStep">下一步</button>
            <button class="gx-reg__prev" @click="step = 0">上一步</button>
          </div>
          <!-- 第三步：验证码 -->
          <div v-else>
            <div class="gx-reg__send-status" v-if="isSendSuccess">
              <div class="gx-reg__phone-icon">📱</div>
              <p class="gx-reg__send-status--text">验证码已发送至</p>
              <p class="gx-reg__send-status--phone">您的手机</p>
            </div>
            <div class="gx-reg__code">
              <div class="gx-input">
                <label class="gx-input__label">验证码</label>
                <input
                  v-model="form.code"
                  class="gx-input__field"
                  :class="{ 'gx-input__field--foc': focusField === 'code' }"
                  placeholder="请输入验证码"
                  @focus="focusField = 'code'"
                  @blur="focusField = ''"
                />
              </div>
              <button type="button" class="gx-input__code" :disabled="codeCountdown > 0" @click="sendCode">
                {{ codeCountdown > 0 ? codeCountdown + 's' : '获取验证码' }}
              </button>
            </div>

            <div class="gx-reg__agree">
              <span class="gx-reg__checkbox" :class="{ 'gx-reg__checkbox--on': form.agree }" @click="form.agree = !form.agree">
                <svg v-if="form.agree" width="10" height="10" viewBox="0 0 8 8" fill="none">
                  <path d="M1 4l2 2 4-4" stroke="#0D1630" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              <span class="gx-reg__agree-text">我已同意并阅读</span>
              <a class="gx-reg__agree-link" href="/user-agreement" @click.prevent="openUserAgreement">《观星树用户协议》</a>
            </div>
            <button class="gx-reg__submit" :disabled="loading" @click="submit">
              {{ loading ? '注册中...' : '完成注册' }}
            </button>
            <button class="gx-reg__prev" @click="step = 1">上一步</button>
          </div>
        </div>

        <p class="gx-reg__login">
          已有账户？
          <a @click="$router.replace('/login')">立即登录</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import common from '../../assets/js/utils/common'
import StarsCanvas from '../../components/newUi/StarsCanvas.vue'
import FloatPts from '../../components/newUi/FloatPts.vue'

export default {
  name: 'NewRegisterPage',
  components: { StarsCanvas, FloatPts },
  data() {
    return {
      stats: [
        { v: '10,000+', l: '星人用户' },
        { v: '1亿+', l: '服务GMV' },
        { v: '99.99%', l: '检测准确' }
      ],
      stepLabels: ['基本信息', '账号安全', '验证完成'],
      step: 0,
      form: {
        phone: '',
        code: '',
        invite: '',
        pwd: '',
        pwd2: '',
        agree: false
      },
      focusField: '',
      loading: false,
      codeCountdown: 0,
      isSendSuccess:false
    }
  },
  created() {
    const query = this.$route.query
    let invite = ''
    if (query.inviteCode) {
      invite = String(query.inviteCode)
      localStorage['inviteCode'] = invite
    } else if (query.invite_code) {
      invite = String(query.invite_code)
      localStorage['inviteCode'] = invite
    } else if (localStorage.getItem('inviteCode')) {
      invite = localStorage.getItem('inviteCode')
    }
    if (invite) this.form.invite = invite
  },
  methods: {
    ...mapActions({
      getCodeData: 'login/getCodeData',
      DoRegister: 'login/DoRegister',
      DoAccountLogin: 'login/DoAccountLogin',
      getUserinfoData: 'login/getUserinfoData'
    }),
    openUserAgreement() {
      const { href } = this.$router.resolve({ path: '/user-agreement' })
      const agreementWindow = window.open(href, '_blank', 'noopener,noreferrer')
      if (agreementWindow) agreementWindow.opener = null
    },
    sendCode() {
      if (!common._verify_mobile(this.form.phone)) {
        this.$message({ message: '请输入正确手机号', type: 'error' })
        return
      }
      this.getCodeData({
        data: { mobile: this.form.phone },
        success: (res) => {
          if (res.code === 200) {
            this.isSendSuccess=true
            this.$message({ message: '发送成功~', type: 'success' })
            this.codeCountdown = 60
            const timer = setInterval(() => {
              this.codeCountdown -= 1
              if (this.codeCountdown <= 0) clearInterval(timer)
            }, 1000)
          } else {
            this.$message({ message: res.message, type: 'error' })
          }
        }
      })
    },
    nextStep() {
      if(this.step === 0){
        if (!this.form.name) {
          this.$message({ message: '请输入真实姓名', type: 'error' })
          return
        }
        if (!common._verify_mobile(this.form.phone)) {
          this.$message({ message: '请输入正确手机号', type: 'error' })
          return
        }
      }
      if(this.step === 1){
        if (!this.form.pwd) {
          this.$message({ message: '请输入密码', type: 'error' })
          return
        }
        if (!this.form.pwd2) {
          this.$message({ message: '请再次输入密码', type: 'error' })
          return
        }
        if (this.form.pwd !== this.form.pwd2) {
          this.$message({ message: '请确保两次输入的密码一致', type: 'error' })
          return
        }
      }
      this.step++
    },
    submit() {
      if (!this.form.code) {
        this.$message({ message: '请获取短信验证码', type: 'error' })
        return
      }
      if (!this.form.agree) {
        this.$message({ message: '请阅读并同意用户协议', type: 'error' })
        return
      }
      if (this.loading) return
      this.loading = true
      this.DoRegister({
        data: {
          mobile: this.form.phone,
          sms_code: this.form.code,
          password: this.form.pwd,
          repeat_password: this.form.pwd2,
          invite_code: this.form.invite || ''
        },
        success: (res) => {
          this.loading = false
          if (res.code === 200) {
            localStorage.removeItem('inviteCode')
            // this.step = 2
            this.handleLogin()
          } else {
            this.$message({ message: res.message, type: 'error' })
          }
        }
      })
    },
    handleLogin(){
      this.DoAccountLogin({
        data: { mobile: this.form.phone, password: this.form.pwd },
        success: (res) => {
          if (res.code === 200) {
            this.getUserinfoData({
              data: {},
              success: (res) => {
                if (res.code !== 200) {
                  this.$message({ message: res.message || '获取用户权限失败', type: 'error' })
                  return
                }
                this.$router.replace('/ucenter').catch(() => {})
              }
            }).catch(() => {
              this.$message({ message: '获取用户权限失败，请重试', type: 'error' })
            })
          } else {
            this.$message({ message: res.message, type: 'error' })
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.gx-reg {
  height: 100vh;
  display: flex;
  overflow: hidden;
  background: linear-gradient(135deg, #1A2855 0%, #243470 55%, #1A2855 100%);
  position: relative;
  font-family: 'Noto Sans SC', sans-serif;
}
.gx-reg__orb {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  animation: gx-orbFloat 10s ease-in-out infinite;
}
.gx-reg__orb--1 {
  left: 32%;
  top: 32%;
  width: 380px;
  height: 380px;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, rgba(212, 169, 70, .22) 0%, transparent 68%);
}
.gx-reg__orb--2 {
  left: 72%;
  top: 68%;
  width: 240px;
  height: 240px;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, rgba(63, 182, 224, .14) 0%, transparent 68%);
}
.gx-reg__back {
  position: absolute;
  top: 24px;
  left: 28px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, .07);
  border: 1px solid rgba(255, 255, 255, .12);
  border-radius: 9px;
  padding: 8px 16px;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #C8C0E0;
  transition: all 0.4s cubic-bezier(.4, 0, .2, 1);
}
.gx-reg__back:hover {
  color: #D4A946;
  border-color: rgba(212, 169, 70, .45);
}
.gx-reg__left {
  width: 55%;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  padding: 0 52px;
  text-align: center;
}
.gx-reg__tree {
  font-size: 96px;
  margin-bottom: 22px;
  display: inline-block;
  animation: gx-treeBreathe 3s ease-in-out infinite;
}
.gx-reg__name {
  font-family: 'Noto Serif SC', serif;
  font-size: 38px;
  font-weight: 700;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #D4A946, #E8B950);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gx-goldGlow 4s ease-in-out infinite;
}
.gx-reg__slogan {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 16px;
  color: #FFFFFF;
  margin-bottom: 6px;
  font-weight: 500;
}
.gx-reg__sub {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 14px;
  color: #C8C0E0;
}
.gx-reg__divider {
  width: 56px;
  height: 1.5px;
  background: linear-gradient(90deg, transparent, #D4A946, transparent);
  margin: 26px auto;
}
.gx-reg__stats {
  display: flex;
  gap: 38px;
}
.gx-reg__stat-v {
  font-family: Inter, monospace;
  font-size: 20px;
  font-weight: 700;
  color: #D4A946;
  margin-bottom: 3px;
}
.gx-reg__stat-l {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: #C8C0E0;
}
.gx-reg__right {
  width: 45%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(26, 40, 85, .6) 0%, rgba(15, 27, 61, .8) 100%);
  overflow-y: auto;
  padding: 24px 0;
}
.gx-reg__panel {
  width: 100%;
  max-width: 400px;
  padding: 0 44px;
  animation: gx-cardIn 0.5s ease-out both;
  box-sizing: border-box;
}
.gx-reg__head {
  text-align: center;
  margin-bottom: 28px;
}
.gx-reg__head-icon {
  font-size: 38px;
  margin-bottom: 8px;
  display: inline-block;
  animation: gx-treeBreathe 3s ease-in-out infinite;
}
.gx-reg__title {
  font-family: 'Noto Serif SC', serif;
  font-size: 26px;
  font-weight: 700;
  color: #FFFFFF;
  margin: 0 0 5px;
  animation: gx-goldGlow 4s ease-in-out infinite;
}
.gx-reg__en {
  font-family: Inter, monospace;
  font-size: 11px;
  color: #00D4FF;
  letter-spacing: 3px;
  margin: 0;
}
.gx-reg__steps {
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
}
.gx-reg__step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.gx-reg__step-line {
  position: absolute;
  top: 13px;
  right: 50%;
  left: -50%;
  height: 1.5px;
  background: rgba(255, 255, 255, .12);
  transition: background 0.5s;
}
.gx-reg__step-line--done {
  background: linear-gradient(90deg, #D4A946, #D4A946);
}
.gx-reg__step-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .07);
  border: 2px solid rgba(255, 255, 255, .16);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  position: relative;
  z-index: 1;
  transition: all 0.35s;
  box-sizing: border-box;
  color:#4a4a6a;
}
.gx-reg__step-dot--active {
  color: #d4a946;
  background: rgba(212, 169, 70, .2);
  border-color: #D4A946;
  box-shadow: 0 0 16px rgba(212, 169, 70, .6);
  animation: gx-stepIn 0.4s ease-out both;
}
.gx-reg__step-dot--done {
  background: #D4A946;
  border-color: #D4A946;
}
.gx-reg__step-check {
  font-size: 12px;
  color: #1A1A2E;
  font-weight: 700;
}
.gx-reg__step-num {
  font-family: Inter, monospace;
  font-size: 11px;
  //color:#4a4a6a;
}
.gx-reg__step-label {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 11px;
  color: #4A4A6A;
  transition: color 0.3s;
}
.gx-reg__step--active .gx-reg__step-label,
.gx-reg__step--done .gx-reg__step-label {
  color: #D4A946;
}
.gx-reg__card {
  border-radius: 20px;
  background: rgba(255, 255, 255, .08);
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  border: 1.5px solid rgba(212, 169, 70, .28);
  box-shadow: 0 8px 40px rgba(0, 0, 0, .45), inset 0 1px rgba(255, 255, 255, .08);
  padding: 28px 26px;
  position: relative;
  overflow: hidden;
}
.gx-reg__card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 15%;
  right: 15%;
  height: 1.5px;
  background: linear-gradient(90deg, transparent, #D4A946, transparent);
}
.gx-input {
  margin-bottom: 16px;
}
.gx-input__label {
  display: block;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #C8C0E0;
  margin-bottom: 7px;
  transition: color 0.4s cubic-bezier(.4, 0, .2, 1);
}
.gx-input__wrap {
  position: relative;
}
.gx-input__field {
  width: 100%;
  height: 50px;
  padding: 0 16px;
  border-radius: 11px;
  background: rgba(255, 255, 255, .08);
  border: 1.5px solid rgba(212, 169, 70, .22);
  box-shadow: inset 0 1px rgba(255, 255, 255, .05);
  color: #FFFFFF;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: all 0.4s cubic-bezier(.4, 0, .2, 1);
}
.gx-input__field--foc {
  background: rgba(212, 169, 70, .06);
  border-color: rgba(212, 169, 70, .7);
  box-shadow: 0 0 0 3px rgba(212, 169, 70, .14), inset 0 1px rgba(255, 255, 255, .07);
}
.gx-input__code {
  height: 50px;
  margin-top: 27px;
  padding: 0 14px;
  border-radius: 11px;
  flex-shrink: 0;
  border: 1px solid rgba(212, 169, 70, 0.4);
  background: rgba(212, 169, 70, 0.1);
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(212, 169, 70);
  white-space: nowrap;
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.gx-input__code:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-reg__agree {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: #C8C0E0;
}
.gx-reg__checkbox {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  border: 1.5px solid rgba(212, 169, 70, .45);
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}
.gx-reg__checkbox--on {
  background: linear-gradient(135deg, #D4A946, #E8B950);
  border-color: transparent;
}
.gx-reg__agree-link {
  color: #D4A946;
  cursor: pointer;
}
.gx-reg__submit {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  cursor: pointer;
  background: linear-gradient(135deg, #D4A946, #E8B950);
  border: none;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A2E;
  box-shadow: 0 6px 22px rgba(212, 169, 70, .45);
  transition: all 0.4s cubic-bezier(.4, 0, .2, 1);
}
.gx-reg__submit:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 32px rgba(212, 169, 70, .65);
}
.gx-reg__submit:disabled {
  background: rgba(212, 169, 70, .35);
  box-shadow: none;
  cursor: not-allowed;
  transform: none;
}
.gx-reg__prev {
  display: block;
  margin: 14px auto 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: #C8C0E0;
  transition: color .2s;
}
.gx-reg__prev:hover {
  color: #D4A946;
}
.gx-reg__login {
  text-align: center;
  margin-top: 20px;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #C8C0E0;
}
.gx-reg__login a {
  color: #D4A946;
  cursor: pointer;
}
.gx-reg__done {
  text-align: center;
  padding: 20px 0 10px;
}
.gx-reg__done-icon {
  font-size: 52px;
  margin-bottom: 14px;
  animation: gx-checkPop 0.4s ease-out both;
}
.gx-reg__done-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 20px;
  font-weight: 700;
  color: #F0EBE0;
  margin-bottom: 8px;
}
.gx-reg__done-sub {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #8A95B0;
  margin-bottom: 24px;
  line-height: 1.7;
}
.gx-reg__send-status{
  text-align: center; padding: 8px 0px 16px;
}
.gx-reg__send-status--text{
  font-size: 14px; color: rgb(232, 228, 240); margin: 0px 0px 4px;
}
.gx-reg__send-status--phone{
  font-size: 15px; font-weight: 600; color: rgb(255, 255, 255); margin: 0px;
}
.gx-reg__phone-icon{
  font-size: 38px; margin-bottom: 10px;
}
.gx-reg__code{
  display: flex;
  gap: 10px;
}
@media (max-width: 900px) {
  .gx-reg__left {
    display: none;
  }
  .gx-reg__right {
    width: 100%;
  }
}
</style>
